import constants from "../../../../../../../appConstants";
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import {SeverityIcon} from "./components";
import { formatMonthDateYearWithoutUTC } from '@dataGrid/gridUtilities';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ showTrailerScac }) {
    return GridConfig.getDefaultConfiguration(showTrailerScac);
  }

  static renderSeverityIcon = (props) => {
    if (!props.value) {
      return null;
    }
    return <SeverityIcon severity={props.value} />;
  };

  static getDefaultConfiguration(showTrailerScac) {
    return {
      title: constants.gridNames.EquipmentDefectGrid,
      keyColumn: "",
      rowSelection: "multiple",
      rowDeselection: true,
      suppressRowTransform: true,
      defaultColDef: {
        lockPinned: true,
        editable: false,
        lockPosition: true,
      },
      columns: [
        {
          headerName: "Equip #",
          field: "equipNumber",
          width: constants.columnWidth.EQUIPMENT,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: "SCAC Code",
          headerTooltip: "SCAC Code",
          field: "scacCode",
          hide: !showTrailerScac,
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Category",
          field: "defectCategory",
          width: constants.columnWidth.CATEGORY,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          tooltipField:"defectCategory"
        },
        {
          headerName: "Sub Category",
          field: "defectSubCategory2",
          width: constants.columnWidth.SUB_CATEGORY,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          tooltipField:"defectSubCategory2"
        },
        {
          headerName: "Defect",
          field: "comments",
          width: constants.columnWidth.DEFECT,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          tooltipField:"comments"
        },
        {
          headerName: "Severity",
          field: "severity",
          width: constants.columnWidth.SEVERITY,
          cellClass: "gridCell-leftAlign",
          cellRenderer: GridConfig.renderSeverityIcon,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Date",
          field: "addedDate",
          width: constants.columnWidth.DEFECT_DATE,
          cellClass: "gridCell-leftAlign",
          valueFormatter: (params) => formatMonthDateYearWithoutUTC(params),
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.MONTHDATEYEAR,
          },
        },
      ],
    };
  }
}
